import React from 'react';
import * as styles from './styles.css';
import { Faq16 } from '@cian/ui-kit/prev';
import { InformationTooltip } from '@cian/ui-kit';
import cn from 'clsx';

export interface IInfoRowProps {
  label?: React.ReactNode;
  title: string;
  description: string;
  descriptionGrey?: boolean;
  crossedContent?: string;
  tooltipContent?: React.ReactNode;
  tooltipHeader?: string;
  testId?: string;
}

export const InfoRow: React.FC<IInfoRowProps> = ({
  title,
  description,
  label,
  descriptionGrey,
  tooltipContent,
  tooltipHeader,
  crossedContent,
  testId,
}) => {
  return (
    <div className={styles['info-row']}>
      <p className={styles['title']}>
        {title}
        {tooltipContent && (
          <InformationTooltip content={tooltipContent} header={tooltipHeader}>
            <span className={styles['tooltip-icon']}>
              <Faq16 color="primary_100" />
            </span>
          </InformationTooltip>
        )}
      </p>
      <div className={cn(styles['description'], descriptionGrey && styles['grey'])}>
        <span data-testid={testId}>{description}</span>
        {crossedContent && <span className={styles['crossed']}>{crossedContent}</span>}
      </div>
      {label && <div>{label}</div>}
    </div>
  );
};
